















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import AppTextSearch from '@/components/AppTextSearch.vue'
import AppTextField from '@/components/AppTextField.vue'
import AppTextarea from '@/components/AppTextarea.vue'
import AppSelector from '@/components/AppSelector.vue'
import AppDatePicker from '@/components/AppDatePicker.vue'
import { IAssetInfoInput } from '@/modules/AccountAsset/interfaces/account-asset-form'

@Component({
  components: {
    AppTextSearch,
    AppTextField,
    AppSelector,
    AppDatePicker,
    AppTextarea
  }
})
export default class AccountAssetFormInfo extends Vue {
  @Prop({ type: Object as () => IAssetInfoInput }) value!: IAssetInfoInput

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
